import { useNotifications } from '../contexts/NotificationContext';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import { Cake, PartyPopper, X } from 'lucide-react';
import Confetti from './Confetti';

export const BirthdayPopup = () => {
  const { birthdayUsers, showBirthdayPopup, closeBirthdayPopup } = useNotifications();

  if (!showBirthdayPopup || birthdayUsers.length === 0) return null;

  const getInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <>
      {showBirthdayPopup && <Confetti />}
      <Dialog open={showBirthdayPopup} onOpenChange={closeBirthdayPopup}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center justify-center gap-2 text-2xl">
              <PartyPopper className="w-8 h-8 text-amber-500" />
              ¡Feliz Cumpleaños!
              <Cake className="w-8 h-8 text-pink-500" />
            </DialogTitle>
          </DialogHeader>
          
          <div className="py-6">
            <p className="text-center text-muted-foreground mb-6">
              Hoy celebramos el cumpleaños de:
            </p>
            
            <div className="space-y-4">
              {birthdayUsers.map((user) => (
                <div 
                  key={user.id}
                  className="flex items-center gap-4 p-4 rounded-xl bg-gradient-to-r from-amber-50 to-pink-50 border border-amber-200"
                >
                  <Avatar className="w-16 h-16 border-4 border-amber-300">
                    <AvatarImage src={user.avatar_url} />
                    <AvatarFallback className="bg-amber-200 text-amber-800 text-xl">
                      {getInitials(user.full_name)}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <h3 className="text-lg font-bold text-amber-900">
                      {user.full_name}
                    </h3>
                    <p className="text-amber-700">
                      ¡Felicidades en tu día especial!
                    </p>
                  </div>
                </div>
              ))}
            </div>
            
            <p className="text-center text-sm text-muted-foreground mt-6">
              La fraternidad PICHIROCES AMAZONICOS les desea un día lleno de alegría
            </p>
          </div>
          
          <div className="flex justify-center">
            <Button 
              onClick={closeBirthdayPopup}
              className="bg-gradient-to-r from-amber-500 to-pink-500 hover:from-amber-600 hover:to-pink-600"
            >
              <PartyPopper className="w-4 h-4 mr-2" />
              ¡Celebrar!
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
